import React from 'react';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom"
import './rsbutton.css'
import deleteImg from "../../assets/img/client-circle-icon.png"
const ActionDeleteFade = ({to, onClick, children}) => {
  return (
    <Link
      to={to}
      className={`btn btn-edit`}
      onClick={onClick}
    >
      <img src={deleteImg} style={{width:24}} /> {children}
    </Link>
  );
};

ActionDeleteFade.propTypes = {
to:PropTypes.string,
onClick: PropTypes.func,
children: PropTypes.string,
};
ActionDeleteFade.defaultProps = {
    to:'#',
    onClick: () => {},
    children:''
  };
export default ActionDeleteFade;
